import apiCall from '../../utility/api';

export interface SAMLConfig {
    company_name: string;
    idp_full_name: string;
    idp_metadata_url: string;
    idp_metadata: string;
    spEntityId: string;
}

export interface OAuthConfig {
    company_name: string;
    idp_full_name: string;
    client_id: string;
    client_secret: string;
    scope: string;
}

export interface SSOConfig {
    ssoStatus: number;
    isSSOEnabled: boolean;
    ssoMethod: 'SAML' | 'OAuth';
    saml: SAMLConfig;
    oauth: OAuthConfig;
}


export const type: { value: string } = { value: 'sso' };

export const getSSOConfig = async (type:string, domain_name:string) => {
    
    const sso_type = type;
    try {
        const { data, status } = await apiCall(`/sso/getSSOConfig`, {domain_name});
        return { data, status };
    } catch (error) {
        console.log("getSSOConfig error=", error);
        return { data: null, status: 'failed' };
    }
};

export const insertSSOConfig = async (config: any) => {
    try {
        return await apiCall(`/sso/insertSSOConfig`, config);
    } catch (error) {
        console.log("addSSOConfig error=", error);
        return { status: false };
    }
};

export const updateSSOConfig = async (config: any): Promise<any> => {
    try {
        return await apiCall(`/sso/updateSSOConfig`, config);
    } catch (error) {
        console.error("updateSSOConfig error=", error);
        return false;
    }
};

export const updateSSOStatus = async (config: any): Promise<any> => {
    try {
        return await apiCall(`/sso/updateSSOStatus`, config);
    } catch (error) {
        console.error("updateSSOStatus error=", error);
        return false;
    }
};

export const clearSSOConfig = async (ssoid: string): Promise<any> => {
    try {
        return await apiCall(`/sso/deleteSSOConfig`, { ssoid });
    } catch (error) {
        console.error("clearSSOConfig error=", error);
        return false;
    }
};



export const saveSSOConfig = async (config: SSOConfig): Promise<boolean> => {
    try {
        // await axios.post(API_URL, config);
        return await apiCall(`/sso/update`, {});
        return true;
    } catch (error) {
        console.error('Error saving SSO config:', error);
        return false;
    }
};

export const defaultConfig = {
    ssoStatus: 0,
    ssoMethod: 'oauth', // or 'OAuth', depending on what you want to be default
    saml: {
        company_name: '',
        idp_full_name: '',
        idp_metadata_url: '',
        idp_metadata: '',
        spEntityId: ''
    },
    oauth: {
        company_name: '',
        idp_full_name: '',
        client_id: '',
        client_secret: '',
        scope: ''
    }
};
